import { useState, useEffect } from 'react';
import useProjectsStatus from 'common/fetchHooks/useProjectsStatus';

const ERROR_VALIDATION_DESCRIPTION = {
  EMPTY_NAME: 'Project name is mandatory',
  EXISTING_NAME:
    'This Project name already exists. Please enter a different name'
};

const useNameValidator = (projectName, curProjectName) => {
  const [isValid, setIsValid] = useState(true);
  const [description, setDescription] = useState('');
  const [shouldValidate, setShouldValidate] = useState(false);

  const { projectsStatuses, loading } = useProjectsStatus({
    withPolling: false
  });

  const isNameEmpty = name => !name;

  const isNameExists = curProjectName => {
    if (loading) {
      return false;
    }
    const projectExistingNames = (projectsStatuses || [])
      .filter(({ name }) => {
        return name.trim() !== projectName.trim();
      })
      .map(({ name }) => name);
    return projectExistingNames.includes(curProjectName.trim());
  };

  useEffect(() => {
    const isEmpty = isNameEmpty(curProjectName);
    const isExisting = isNameExists(curProjectName);
    if (isEmpty) {
      setDescription(ERROR_VALIDATION_DESCRIPTION.EMPTY_NAME);
    }
    if (isExisting) {
      setDescription(ERROR_VALIDATION_DESCRIPTION.EXISTING_NAME);
    }
    setIsValid(!isEmpty && !isExisting);
  }, [curProjectName, loading, shouldValidate]);

  return {
    isValid,
    description,
    started: shouldValidate,
    startValidation: () => setShouldValidate(true)
  };
};

export default useNameValidator;
